"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fonts = exports.fontWeights = exports.fontSizes = void 0;
const fonts = exports.fonts = {
  heading: `"Open Sans", sans-serif`,
  body: `"Open Sans", sans-serif`
};
const fontSizes = exports.fontSizes = {
  '5xl': '3.5rem',
  // 56px
  '4xl': '3rem',
  // 48px
  '3xl': '2.5rem',
  // 40px
  '2xl': '2rem',
  // 32px
  xl: '1.5rem',
  // 24px
  lg: '1.25rem',
  // 20px
  md: '1.125rem',
  // 18px
  base: '1rem',
  // 16px
  sm: '0.875rem',
  // 14px
  xs: '0.75rem' // 12px
};
const fontWeights = exports.fontWeights = {
  light: 300,
  normal: 400,
  semibold: 600,
  bold: 700
};